import { render } from "./ExpertChatMessage.vue?vue&type=template&id=151d7680&scoped=true"
import script from "./ExpertChatMessage.vue?vue&type=script&lang=js"
export * from "./ExpertChatMessage.vue?vue&type=script&lang=js"

import "./ExpertChatMessage.vue?vue&type=style&index=0&id=151d7680&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151d7680"]])

export default __exports__